export default {
  mySetting_nickName:'昵稱：',
  mySetting_switch_home:'切換首頁',
}
